<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="flexBox">
      <text-title mainTitle="电控参数" subheading="" />
      <a @click="toModifyConfig">修改</a>
    </div>
    <ul>
      <li>
        <b>名称：</b>
        <span>{{ name || '暂无' }}</span>
      </li>
      <li>
        <b>电费(元/度)：</b>
        <span>{{ unitPrice || '暂无' }}</span>
      </li>
      <li>
        <b>提示语：</b>
        <span>{{ warmMessage || '暂无' }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  import {commonConfig} from '../common'
  import {errorHandler} from '../../../utils/errorHandler'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import {httpUrl} from '../../api/httpUrl'
  import TextTitle from '../../../components/Text/TextTitle'

  const breadcrumb = [
    commonConfig.firstBreadcrumb,
    {label: '人脸配置'}
  ]
  export default {
    components: {
      TextTitle,
      Breadcrumb
    },
    name: 'electronic-config',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧用电',
            name: 'electronic-config'
          }, {
            value: '基本配置',
          }],
        },
        name: '',
        unitPrice: '',
        warmMessage: ''
      }
    },
    created () {
      this.getElectricConfigData()
    },
    methods: {
      toModifyConfig () {
        this.$router.push({
          name: 'modify-electronic-config'
        })
      },
      getElectricConfigData () {
        this.$axios.post(`${httpUrl.host}/gy-electric/basicConfig/getConfig`, {})
          .then(res => {
            let data = res.data.data
            if (data) {
              this.name = data.configName
              this.unitPrice = data.unitPrice
              this.warmMessage = data.warmMessage
            }
          })
          .catch(errorHandler('获取配置数据失败'))
      }
    }
  }
</script>

<style scoped>
  .main_right {
    text-align: left;
  }

  .flexBox {
    display: flex;
    justify-content: space-between;
  }

  .flexBox a{
    line-height: 58px;
    margin-right: 40px;
    cursor: pointer;
  }
  .flexBox a:hover{
    color: #00a0e6;
  }

  .main_right ul {
    width: 80%;
    margin: 10px auto 0;
    line-height: 40px;
  }

  .main_right ul li {
    width: 100%;
    padding: 4px 0;
    margin-bottom: 10px;
  }
  .main_right ul li b {
    color: #48576A;
    font-weight: 400;
    display: inline-block;
    width: 120px;
    text-align: right;
    margin-right: 15px;
  }

  .main_right ul li span{
    color:#333;
  }
</style>



// WEBPACK FOOTER //
// src/view/ElectronicControl/electronic-config/electronic-config.vue